import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=20323618&scoped=true&"
import script from "./QA.vue?vue&type=script&lang=js&"
export * from "./QA.vue?vue&type=script&lang=js&"
import style0 from "./QA.vue?vue&type=style&index=0&id=20323618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20323618",
  null
  
)

export default component.exports